import React, { Component } from "react";
import "./TopBanner.css";

class TopBanner extends Component {
  render() {
    return (
      <div className="TopBannerDiv LowPanel">
        <span className="TopBannerTitle PrimaryText">PROTOS</span>
        <span className="TopBannerSubTitle SecondaryText">PROTOTYPE THRICE, IMPLEMENT ONCE</span>
      </div>
    );
  }
}

export default TopBanner;
